<template lang="pug">
	.asset-preview-mini(v-if="showed" v-pseudo-modal="'asset-preview'" :style="{top: top + 'px', right: right + 'px'}")
		.img-asset-preview(v-if="asset && (asset.type === 'image' || asset.type === 'atlas' || asset.guid || asset.type === 'svg')")
			img(:src="assetURL")

</template>

<script>

	import Screen 			from './../../mixins/screen';
	import { Asset } 		from './../../services/Asset';

	export default {
		name: "AssetPreviewMini",
		mixins: [Screen],
		screen: {
			events: {
				"Show Asset Preview": function(asset, e, el) {

					this.asset = asset;

					if (asset.type === 'image' || asset.type === 'svg')
						this.assetURL = Asset.getAssetActualUrl(asset, {addTimestamp: true});
					if (asset.guid) {
						this.assetURL = `https://v-cdn.prvk.io/${asset.guid}/thumbnail.jpg?v=${Date.now()}`;
					}

					this.update();

					let rect = el.getBoundingClientRect();

					this.top = rect.top;
					this.right = document.body.clientWidth - rect.left;

					Broadcast.call("Pseudo Modal Show", ["asset-preview"]);

				},
				"Hide Asset Preview": function() {

					this.asset = null;

					this.update();

					Broadcast.call("Pseudo Modal Hide", ["asset-preview"]);

				},
				"Selected Project Changed": function() {

					this.assetsPath = Project.getSelectedProjectAssetsPath();

					this.update();

				}
			}
		},
		data() {

			this.asset = null;
			this.assetURL = '';

			return {
				showed: true,
				top: 0,
				right: 0
			};

		},
		computed: {

		},
		methods: {
			collectData() {



			}
		}
	}
</script>

<style lang="sass">

	.asset-preview-mini
		position: absolute
		z-index: 10000
		top: 0
		right: 0
		border-radius: 0.25rem
		padding: 0.25rem
		border: 1px solid #23282c
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		background-color: #3a4149

		.img-asset-preview

			img
				max-width: 100px
				max-height: 100px

</style>
